import { z } from 'zod'

const emailLine = z.string().email()

export const mailSettingsFormSchema = z.object({
  host: z.string().min(1, 'Host ist erforderlich'),
  port: z.coerce.number().int().min(1, 'Ungültiger Port').max(65535, 'Ungültiger Port'),
  user: z.string().optional(),
  pass: z.string().optional(),
  from: z.string().email('Ungültige Absenderadresse'),
  werkhofleiterEmailsRaw: z.string().refine(
    (v) => v.trim() === '' || v.split('\n').filter(Boolean).every((line) => emailLine.safeParse(line.trim()).success),
    { message: 'Ungültige E-Mail-Adresse' },
  ),
})

export type MailSettingsFormValues = z.infer<typeof mailSettingsFormSchema>
